import { defineStore } from "pinia";

export const useGraphlyTemplatesStore = defineStore("GraphlyTemplatesStore", () => {
	const dataobjectShape = "https://cdn.graphly.dev/@livereader/dataobject/latest";
	const eventShape = "https://cdn.graphly.dev/@livereader/event/latest";
	const genericConditionShape = "https://cdn.graphly.dev/@livereader/generic-condition/latest";
	const processShape = "https://cdn.graphly.dev/@livereader/process/0.0.3";
	const taskShape = "https://cdn.graphly.dev/@livereader/activity/latest";
	const logicGateShape = "https://cdn.graphly.dev/@livereader/generic-logic-gate/latest";
	const genericPill = "https://cdn.graphly.dev/@livereader/generic-pill/latest";
	const cellBodyShape = "https://cdn.graphly.dev/@livereader/cell-body/1.0.0";
	const cellSatelliteShape = "https://cdn.graphly.dev/@livereader/cell-satellite/1.0.0";
	const workspaceShape = "https://cdn.graphly.dev/@livereader/workspace/1.0.1";

	return {
		dataobjectShape,
		eventShape,
		genericConditionShape,
		processShape,
		taskShape,
		logicGateShape,
		genericPill,
		cellBodyShape,
		cellSatelliteShape,
		workspaceShape,
	};
});
